import { ownerDocument } from "./owner-document";

/**
 * Returns the window object associated with a given DOM node.
 *
 * @param {Node | undefined} node - The DOM node to retrieve the window for. If undefined, defaults to the global window.
 * @returns {Window} The window object associated with the given node, or the global window if none is found.
 */
export function ownerWindow(node) {
  const doc = ownerDocument(node);
  return doc.defaultView || window;
}
